import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import FHIR, { client } from "fhirclient";

@Injectable({
    providedIn: 'root'
})
export class AppService {
    private messageSource = new BehaviorSubject<any>(null);
    currentMessage = this.messageSource.asObservable();

    changeMessage(message: any) {
        this.messageSource.next(message);
    }

    // login() {
    //     FHIR.oauth2.authorize({
    //         "client_id": "smart-person",
    //         "scope": "openid launch patient/*.read patient/*.write offline_access fhir/*.*",
    //         "redirectUri": "",
    //         iss: "https://veinscdr.mhnexus.com/smartR4"
    //     }).then(x => { }).catch((error) => { });
    // }


    login() {
        if (sessionStorage.getItem("authenticated") != "true") {
            FHIR.oauth2.authorize({
                "client_id": "smart-person",
                "scope": "openid launch patient/*.read patient/*.write offline_access fhir/*.*",
                "redirectUri": "",
                iss: "https://veinscdr.mhnexus.com/smartR4"
            }).then(x => {
                sessionStorage.setItem("authenticated", "true");
            }).catch((error) => {
            });
        }
    }
}
